// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"c4c1eba7","152":"810f1a0d","787":"df02e639","863":"d2e6d380"}[chunkId] + ".chunk.js";
};